module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("User Profile")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (this.UserPersonalDetail.userId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {},
    on: {
      "click": function($event) {
        _vm.reset('dialog2')
      }
    }
  }, [_vm._v("Reset Password")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog', {
    ref: "dialog2",
    staticClass: "HereDialogPass",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": false
    }
  }, [_c('md-dialog-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', [_c('u', [_vm._v("Reset Password")])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-dense modal-close-btnn modalClose",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "md-has-password",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "password",
      "id": "newPassword",
      "name": "newPassword"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "newPassword", $$v)
      },
      expression: "PasswordModal.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "password",
      "id": "confPassword",
      "name": "confPassword"
    },
    on: {
      "keyup": _vm.samePassword
    },
    model: {
      value: (_vm.PasswordModal.confPassword),
      callback: function($$v) {
        _vm.$set(_vm.PasswordModal, "confPassword", $$v)
      },
      expression: "PasswordModal.confPassword"
    }
  }), _vm._v(" "), (_vm.PasswordModal.passNotMatchErr != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passNotMatchErr))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopDia",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_c('u', [_vm._v("User Details")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "employeeName",
      "name": "employeeName"
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeName),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeName", $$v)
      },
      expression: "UserPersonalDetail.employeeName"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.employeeName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.employeeName))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "employeeCode",
      "name": "employeeCode",
      "disabled": ""
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeCode),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeCode", $$v)
      },
      expression: "UserPersonalDetail.employeeCode"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.employeeCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.employeeCode))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Base Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.baseLocationData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Employee Location",
      "isDisabled": ""
    },
    model: {
      value: (_vm.UserPersonalDetail.baseLocation),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "baseLocation", $$v)
      },
      expression: "UserPersonalDetail.baseLocation"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.baseLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.baseLocation))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Mobile No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mobileNo",
      "name": "mobileNo"
    },
    model: {
      value: (_vm.UserPersonalDetail.mobileNo),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "mobileNo", $$v)
      },
      expression: "UserPersonalDetail.mobileNo"
    }
  })], 1), _vm._v(" "), (!_vm.UserPersonalDetail.mobileNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.mobileNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Landline No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "landLineNo",
      "name": "landLineNo"
    },
    model: {
      value: (_vm.UserPersonalDetail.landLineNo),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "landLineNo", $$v)
      },
      expression: "UserPersonalDetail.landLineNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Email (Username)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "email",
      "name": "email",
      "disabled": ""
    },
    on: {
      "keyup": _vm.isEmailValid
    },
    model: {
      value: (_vm.UserPersonalDetail.email),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "email", $$v)
      },
      expression: "UserPersonalDetail.email"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.email))]) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmailFormat))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Designation")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.designationData,
      "option-value": "designation",
      "option-text": "designation",
      "placeholder": "Select Employee Designation",
      "isDisabled": ""
    },
    model: {
      value: (_vm.UserPersonalDetail.designation),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "designation", $$v)
      },
      expression: "UserPersonalDetail.designation"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.designation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.userErrorList.designation))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Preference")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Transport Preference")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Transport Preferenc"
    },
    model: {
      value: (_vm.UserPersonalDetail.transportTypePre),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "transportTypePre", $$v)
      },
      expression: "UserPersonalDetail.transportTypePre"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.UserPersonalDetail.designation != 'HOD' &&
    _vm.UserPersonalDetail.designation != 'Admin' &&
    _vm.UserPersonalDetail.designation != '' &&
    _vm.userMasterList.length > 0 &&
    _vm.UserPersonalDetail.departmentId1.length > 0
  ) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (
    _vm.UserPersonalDetail.designation != 'HOD' &&
    _vm.UserPersonalDetail.designation != 'Admin' &&
    _vm.UserPersonalDetail.designation != '' &&
    _vm.userMasterList.length > 0 &&
    _vm.UserPersonalDetail.departmentId1.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(this.UserPersonalDetail.designation == "manager" ?
    "Employee HOD" :
    "Employee Manager"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.userMasterList,
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": _vm.UserPersonalDetail.designation == 'manager' ?
        'Select HOD' :
        'Select Manager',
      "isDisabled": ""
    },
    model: {
      value: (_vm.UserPersonalDetail.employeeHODId),
      callback: function($$v) {
        _vm.$set(_vm.UserPersonalDetail, "employeeHODId", $$v)
      },
      expression: "UserPersonalDetail.employeeHODId"
    }
  }), _vm._v(" "), (!_vm.UserPersonalDetail.employeeHODId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.employeeHodError))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.NoteArray == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(_vm.UserPersonalDetail.designation != 'manager') ? _c('h4', {
    staticClass: "error"
  }, [_vm._v("\n            Note:-You Do Not Have Any Manager For Selected Employee Department..!\n          ")]) : _c('h4', {
    staticClass: "error"
  }, [_vm._v("\n            Note:-You Do Not Have Any HOD For Selected Manager Department..!\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.UserPersonalDetail.designation != 'HOD' &&
    _vm.UserPersonalDetail.designation != 'Admin' &&
    _vm.UserPersonalDetail.designation != '' &&
    _vm.userMasterList.length > 0 &&
    _vm.UserPersonalDetail.departmentId1.length > 0
  ) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.error.message.length > 0 ? _vm.error.message : "") + "\n          ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-button-color",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("Update Profile")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('u', [_vm._v("Department")])]), _vm._v(" "), (_vm.UserPersonalDetail.departmentId1.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.employeeDepartmentErr))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.designation != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showSegmentArrayList), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": 30
      }
    }, [(index == 0 || index % 3 == 0) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }) : _vm._e(), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.departmentId,
        "name": 'employeeDepartment' + (index + 1),
        "id": 'employeeDepartment' + (index + 1),
        "disabled": ""
      },
      on: {
        "change": function($event) {
          _vm.employeeDepartmentSelect(segmentNameArray.departmentId, index)
        }
      },
      model: {
        value: (_vm.UserPersonalDetail.employeeDepartment[index]),
        callback: function($$v) {
          _vm.$set(_vm.UserPersonalDetail.employeeDepartment, index, $$v)
        },
        expression: "UserPersonalDetail.employeeDepartment[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.departmentName))])], 1)
  })) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.UserPersonalDetail.pagePermision.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('u', [_vm._v("Select Permision")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.UserPersonalDetail.pagePermision.length > 0) ? _c('div', _vm._l((_vm.UserPersonalDetail.pagePermision), function(segmentNameArray1, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(segmentNameArray1.departmentName))])], 1), _vm._v(" "), _vm._l((segmentNameArray1.pageName), function(segmentNameArray, index1) {
      return _c('md-layout', {
        key: index1,
        attrs: {
          "md-flex": 30
        }
      }, [(index1 == 0 || index1 % 3 == 0) ? _c('md-layout', {
        attrs: {
          "md-flex": "15"
        }
      }) : _vm._e(), _vm._v(" "), _c('md-layout', {
        attrs: {
          "md-flex": "5"
        }
      }), _vm._v(" "), _c('md-checkbox', {
        staticClass: "md-primary",
        class: _vm.UserPersonalDetail.finalPagePermision.indexOf(segmentNameArray) >= 0 ?
          'md-checked checkedNew' + segmentNameArray1.pageId + (index1 + 1) :
          'checkedNew' + segmentNameArray1.pageId + (index1 + 1),
        attrs: {
          "md-value": segmentNameArray,
          "name": 'deptMas' + (index1 + 1),
          "id": 'deptMas' + (index1 + 1),
          "disabled": ""
        },
        on: {
          "change": function($event) {
            _vm.employeePageName(segmentNameArray, index1, segmentNameArray1.pageId)
          }
        }
      }, [_vm._v(_vm._s(segmentNameArray))])], 1)
    })], 2)
  })) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d8de43d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/userManagement/userProfile.vue
// module id = 2773
// module chunks = 0